import axios from 'axios';

// const API_URL = process.env.REACT_APP_API_URL || (process.env.NODE_ENV !== 'production' ? 'https://psx.trendsinpakistan.com/api' : 'http://localhost:5000/api');
let API_URL = 'https://psx.trendsinpakistan.com/api';
if (window.location.hostname.includes('localhost')) API_URL = 'http://localhost:5000/api';
const api = axios.create({
  baseURL: API_URL
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

// Trade APIs
export const getTrades = (portfolioId = 'all') => api.get(`/trades?portfolioId=${portfolioId}`);
export const createTrade = (tradeData) => api.post('/trades', tradeData);
export const deleteTrade = (id) => api.delete(`/trades/${id}`);
export const updateTrade = (id, tradeData) => api.put(`/trades/${id}`, tradeData);

// Cash APIs
export const getCashTransactions = (portfolioId = 'all') => api.get(`/cash?portfolioId=${portfolioId}`);
export const addCashTransaction = (data) => api.post('/cash', data);
export const updateCashTransaction = (id, data) => api.put(`/cash/${id}`, data);
export const deleteCashTransaction = (id) => api.delete(`/cash/${id}`);

// Company Data (Public)
export const fetchCompanyProfile = (symbol) => api.get(`/company/${symbol}`);

// Notification endpoints
export const getNotifications = (skip = 0) => api.get(`/notifications?skip=${skip}`);
export const markNotificationRead = (id) => api.put(`/notifications/${id}/read`);
export const markAllNotificationsRead = () => api.put('/notifications/read-all');

// Scraper APIs
export const scrapePrice = (symbol) => api.get(`/scrape/${symbol}`);
export const getAllPricesDb = () => api.get('/scrape/db/all');

// Dividend APIs
export const getDividends = (portfolioId = 'all') => api.get(`/dividends?portfolioId=${portfolioId}`);
export const createDividend = (dividendData) => api.post('/dividends', dividendData);
export const deleteDividend = (id) => api.delete(`/dividends/${id}`);

// Admin Endpoints
export const getAdminUsers = () => api.get('/admin/users');
export const getAdminUserDetails = (userId) => api.get(`/admin/users/${userId}`);
export const getAdminUserPortfolios = (userId) => api.get(`/admin/users/${userId}/portfolios`);
export const updateAdminUser = (userId, data) => api.put(`/admin/users/${userId}`, data);
export const resetAdminUserPassword = (userId, passwordData) => api.put(`/admin/users/${userId}/password`, passwordData);
export const toggleUserBlock = (userId) => api.put(`/admin/users/${userId}/block`);
export const impersonateUser = (userId) => api.post(`/admin/users/${userId}/impersonate`);

// Auth APIs
export const registerUser = (userData) => api.post('/auth/register', userData);
export const loginUser = (credentials) => api.post('/auth/login', credentials);
export const getAuthUser = () => api.get('/auth/me');
export const updateProfile = (profileData) => api.put('/auth/profile', profileData);
export const updatePassword = (passwordData) => api.put('/auth/password', passwordData);

// Portfolio History API
export const getPortfolioHistory = (portfolioId = 'all') => api.get(`/portfolio/history?portfolioId=${portfolioId}`);

// Portfolio CRUD APIs
export const getPortfolios = () => api.get('/portfolios');
export const createPortfolio = (data) => api.post('/portfolios', data);
export const renamePortfolio = (id, data) => api.put(`/portfolios/${id}`, data);
export const updatePortfolio = (id, data) => api.put(`/portfolios/${id}`, data);
export const deletePortfolio = (id) => api.delete(`/portfolios/${id}`);
export const transferSecurity = (data) => api.post('/portfolios/transfer-security', data);

// Watchlist APIs
export const getWatchlists = () => api.get('/watchlists');
export const createWatchlist = (data) => api.post('/watchlists', data);
export const renameWatchlist = (id, data) => api.put(`/watchlists/${id}/rename`, data);
export const deleteWatchlist = (id) => api.delete(`/watchlists/${id}`);
export const addWatchlistSymbol = (id, data) => api.post(`/watchlists/${id}/symbols`, data);
export const removeWatchlistSymbol = (id, symbol) => api.delete(`/watchlists/${id}/symbols/${symbol}`);
export const getWatchlistPrices = (id) => api.get(`/watchlists/${id}/prices`);

// Mutual Fund (Daily Balance Tracker) APIs
export const getMutualFundEntries = (portfolioId = 'all') => api.get(`/mutual-funds?portfolioId=${portfolioId}`);
export const saveMutualFundEntry = (data) => api.post('/mutual-funds', data);
export const bulkImportMutualFundEntries = (data) => api.post('/mutual-funds/bulk', data);
export const updateMutualFundEntry = (id, data) => api.put(`/mutual-funds/${id}`, data);
export const deleteMutualFundEntry = (id) => api.delete(`/mutual-funds/${id}`);

export default api;
